import { render, staticRenderFns } from "./TileGridWidgetSplitTile.vue?vue&type=template&id=1c278180&scoped=true"
import script from "./TileGridWidgetSplitTile.vue?vue&type=script&setup=true&lang=ts"
export * from "./TileGridWidgetSplitTile.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TileGridWidgetSplitTile.vue?vue&type=style&index=0&id=1c278180&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c278180",
  null
  
)

export default component.exports